import React from 'react';
import Button from '../../shared/components/Form/Button';

import './SPARQLEnpointInterface.css';

   const SPARQLEnpointInterface = props => {
   
        return (<React.Fragment>
            <input type="text" 
            id="endpointurl" 
            value={props.endpoint} 
            onChange={props.endpointTextChangeHandler} 
            size="40" 
            placeholder="Enter SPARQL Endpoint URL..."/>
            <Button type="button" inverse 
            disabled={!props.setspclButtonVailidity} 
            onClick={props.getSpatialClasses}>Get Classes</Button>
            <p className=""><i>*Enter a valid SPARQL Endpoint e.g. https://dbpedia.org/sparql. <br/>
            Press Get Classes to retrieve classes that contain 10 to 10000 <br/>
            spatial point entities using the W3C Basic Geo ontology.</i></p> 
            {!props.spatialClasses ? null : 
            <select name="spClasses" className="classSelect"  onChange={props.onClassChange} value={props.spatialClass}>
            {props.spatialClasses && props.spatialClasses.map((cs,index) => <option key={index} value={cs.t.value}>{cs.t.value}</option>)}
            </select>}
    </React.Fragment>)
}

export default SPARQLEnpointInterface;